import {api} from 'lib/url'
import {useEvent} from 'Event/EventProvider'
import {Property} from 'organization/Event/Services/Apps/Hubspot/Config/HubspotPropertiesProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import {Attendee} from 'Event/attendee'

export type HubspotTag = {
  property_label: string | null
  property_name: string | null
  property_type: Property['type'] | null
  property_value: string | null
}

export function useAddTag() {
  const {client, event} = useEvent()

  const url = api(`/events/${event.id}/integrations/hubspot/add_tag`)
  return (tag: HubspotTag) => {
    try {
      client.post(url, tag)
    } catch {
      // Ignore errors, failing to add a tag should
      // not break the app.
    }
  }
}

export function useTestTag() {
  const {event} = useEvent()
  const {client} = useOrganization()

  const url = api(`/events/${event.id}/integrations/hubspot/test_tag`)
  return async (tag: HubspotTag, attendee: Attendee): Promise<void> => {
    return await client.post(url, {
      tag,
      attendee_id: attendee.id,
    })
  }
}
